<template>
  <section id="dashboard-ecommerce">
    <div>
      <pharmaciens-list-table />
    </div>
  </section>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'

import { getUserData } from '@/auth/utils'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import pharmaciensListTable from '../../components/pharmaciens/pharmaciensList.vue'
export default {
  components: {
    BRow,
    BCol,
    pharmaciensListTable,
  },
  data() {
    return {
      data: {
      }
    }
  },
  created() {
   
  },
  methods: {
    getHomeRouteForLoggedInUser
  },
  mounted() {
    if (getUserData() == null) {
      // console.log('ejfkejfk')
      this.$router.replace(this.getHomeRouteForLoggedInUser(''))
      
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>




